<script lang="ts">
	import { onDestroy, onMount } from "svelte";
	import { yyyy, zzzz } from "../../../store.svelte";
	import { toast } from "../../../lib/toast.svelte.ts";
	import Fa from "svelte-fa";
	import {
		faPlusSquare,
		faMinusSquare,
		faHourglass,
	} from "@fortawesome/free-regular-svg-icons";

	import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
	let {
		iama,
		lw_table,
		lw_id,
		phase,
		lw_table_pkid,
		feeder_id,
		clkd,
		i,
		duration,
		_,
		network_count,
		customer_minutes,
	} = $props();

	const url: string = yyyy.uri.api;
	let metrics = $state({});
	let showMetrics = $state(false);
	let isWorking = $state(false);

	//let duration: HTMLInputElement = $state();

	let makeLarge = () => {
		console.log('makeLarge')
		zzzz.emit("makeLarge", found);
	};

	let makeSmall = () => {
		zzzz.emit("makeSmall");
	};
	
	let outageMetrics = async () => {
		// Validate duration input
		if (!duration || duration <= 0) {
			toast.warning("Please enter a valid duration greater than 0 minutes");
			return;
		}

		isWorking = true;
		let _bodyprep = {
			duration: duration,
			lw_phase: "ABC*",
			lw: yyyy.sesh.activeLivewire.wireident,
		};
		if (iama === "EDGE") {
			_bodyprep.lat = clkd.lat;
			_bodyprep.lng = clkd.lng;
		}

		if (iama === "NODE") {
			_bodyprep.lw_id = lw_id;
		}

		let _body = JSON.stringify(_bodyprep);

		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let fetchopts = { method: "post", body: _body, headers: _hdrs };
		const response = await fetch(`${url}/rpc/findmetrics`, fetchopts);

		if (response.ok) {
			let data = await response.json();
			metrics = data.findmetrics;
			metrics.duration = duration;
			yyyy.outages[i].metrics = metrics;
			showMetrics = true;
			isWorking = false;
		}
	};

	let on = () => {
		zzzz.emit("HILITE", { outage: _, bye: false });
	};
	let ov = () => {

		zzzz.emit("HILITE", { outage: _, bye: true });
	};
	onMount(() => {
		zzzz.emit("addOutage", { clkd: clkd, i: i });
	});

	let remove = () => {
		zzzz.emit("removeOutage", { i: i, _: _ });
		yyyy.outages.splice(i, 1);
	};

	onDestroy(() => {
		console.log("ondeestroy: ", i, _);
	});
</script>

<div onmouseover={on} onmouseout={ov}>
	<div class="outage">
		<div class="outage-icon-list">
			<span class="outage-number">{i + 1}</span>
		</div>
		<div class="outage-details">
			<span class="keep-it-short">{lw_table_pkid}</span>
			<span>{lw_table}</span>
			<span>{phase}</span>
		</div>
	</div>
	<!--
{iama} |
{lw_table}|
{lw_table_pkid}|
{lw_id} |
{phase} |
{clkd} | :: {_} :: -->
	<!--
{#if showMetrics}
	<table class="table">
		<tbody>
			<tr>
				<th
					><abbr title="System Average Interruption Duration Index">SAIDI</abbr></th
				>
				<td>{metrics.saidi}</td>
			</tr>
			<tr>
				<th
					><abbr title="Customer Average Interruption Duration Index">CAIDI</abbr></th
				>
				<td>{metrics.caidi}</td>
			</tr>
			<tr>
				<th
					><abbr title="System Average Interruption Freuqncy Index">SAIFI</abbr></th
				>
				<td>{metrics.saifi}</td>
			</tr>
			<tr>
				<th
					><abbr title="Customer Average Interruption Duration Index">CAIFI</abbr></th
				>
				<td>{metrics.caifi}</td>
			</tr>
			<tr>
				<th
					><abbr title="Customer Interrupted per Interruption Index">CIII</abbr></th
				>
				<td>{metrics.ciii}</td>
			</tr>
		</tbody>
	</table>
{/if}
-->
	<div class="field has-addons">
		{#if !showMetrics}
			<!--
			<div class="control">
				<button class="button is-info"> A </button>
			</div>
			<div class="control">
				<button class="button is-info"> B </button>
			</div>
			<div class="control">
				<button class="button is-info"> C </button>
			</div> -->
			<div class="control is-expanded">
				<input
					class="input"
					bind:value={duration}
					type="number"
					min="0"
					step="1"
					placeholder="Outage duration in minutes"
				/>
			</div>

			<div class="control">
				<button class="button is-primary" class:is-loading={isWorking} onclick={outageMetrics}>
					<Fa icon={faPlus} size="1.5x" />
				</button>
			</div>
		{/if}
		{#if showMetrics}
			<div class="control">
				<button class="button is-static"> Customer Minutes </button>
			</div>
			<div class="control is-expanded">
				<button class="button is-static is-fullwidth">
					{metrics.customer_minutes}
				</button>
			</div>

			<div class="control">
				<button class="button is-danger" onclick={remove}>
					<Fa icon={faMinus} size="1.5x" />
				</button>
			</div>
		{/if}
	</div>
</div>

<style>
	.outage {
		width: 100%;
		display: flex;
		align-items: center;
		gap: 12px;
	}
	
	.outage-icon-list {
		width: 24px;
		height: 24px;
		background-color: #ff3e00;
		border: 2px solid white;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	}
	
	.outage-icon-list .outage-number {
		color: white;
		font-weight: bold;
		font-size: 10px;
		font-family: 'Ubuntu', sans-serif;
		line-height: 1;
	}
	
	.outage-details {
		display: flex;
		justify-content: space-between;
		flex: 1;
		gap: 8px;
	}
	
	.keep-it-short {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		max-width: 30%;
	}

	/* Hide number input spinner buttons */
	input[type="number"]::-webkit-outer-spin-button,
	input[type="number"]::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}
</style>
